import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getErrorStateSelector } from '@redux/selectors/error-selectors';
import { setSubmissionFailed } from '@redux/actions/submission-actions';
import { getLanguageContent } from '@redux/selectors/language-selectors';
import styles from "./error-page.less";

export const ErrorPage = () => {
    const dispatch = useDispatch();
    const content = useSelector(getLanguageContent);
    const errorState = useSelector(getErrorStateSelector);

    useEffect(() => {
        dispatch(setSubmissionFailed(true));
    }, []);

    useEffect(() => {
        document.title = "Capture Error";
    });

    return (
        <div className={styles.errorPage}>
            <h4>{content.error.header}</h4>
            <span>{content.error.message}</span>
            {errorState.asi && (
                <span>{content.error.transactionId}: {errorState.asi}</span>
            )}
        </div>
    );
};